import { FilterPanelContext } from "./filter-panel.context";
import type { FilterPanelRootProps } from "./types-filter-panel";
import { useFilterPanel } from "./use-filter-panel";

/** Estado do painel (linhas, rascunho, Aplicar/Limpar); não desenha nada: componha `Card` e as partes dentro dele. */
export function FilterPanelRoot({ children, ...options }: FilterPanelRootProps) {
  const viewModel = useFilterPanel(options);

  return <FilterPanelContext.Provider value={viewModel}>{children}</FilterPanelContext.Provider>;
}
FilterPanelRoot.displayName = "FilterPanel.Root";
